export const WildRiftDivisions = [
  'Iron IV',      // 00
  'Iron III',     // 01
  'Iron II',      // 02
  'Iron I',       // 03
  'Bronze IV',    // 04
  'Bronze III',   // 05
  'Bronze II',    // 06
  'Bronze I',     // 07
  'Silver IV',    // 08
  'Silver III',   // 09
  'Silver II',    // 10
  'Silver I',     // 11
  'Gold IV',      // 12
  'Gold III',     // 13
  'Gold II',      // 14
  'Gold I',       // 15
  'Platinum IV',  // 16
  'Platinum III', // 17
  'Platinum II',  // 18
  'Platinum I',   // 19
  'Emerald IV',   // 20
  'Emerald III',  // 21
  'Emerald II',   // 22
  'Emerald I',    // 23
  'Diamond IV',   // 24
  'Diamond III',  // 25
  'Diamond II',   // 26
  'Diamond I',    // 27
  'Master',       // 28
  'Grandmaster',  // 29
  'Challenger',   // 30
  'Unranked',     // 31
];
